import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { DestinationTypeahead, IDestination, useSearchWidgetContext } from 'features/search-widget';

function Destinations(): JSX.Element {
  const l10n = useLocalization();

  const { selectedLob, fromDestination, toDestination, setFromDestination, setToDestination } =
    useSearchWidgetContext();

  function handleDestinationClear(leg: string): () => void {
    const setDestination = (leg === 'from' && setFromDestination) || (leg === 'to' && setToDestination);

    return function handleDestinationClear(): void {
      setDestination?.(undefined);
    };
  }

  function handleDestinationUpdate(leg: string): (nextDestination: IDestination) => void {
    const setDestination = (leg === 'from' && setFromDestination) || (leg === 'to' && setToDestination);

    return function handleDestinationUpdate(nextDestination: IDestination): void {
      setDestination?.(nextDestination);
    };
  }

  const showMultipleInputs = selectedLob?.id === 'flights';

  return (
    <section className="destination">
      <UitkLayoutGrid space="three" columns={showMultipleInputs ? 2 : 1}>
        {showMultipleInputs && (
          <UitkLayoutGridItem>
            <DestinationTypeahead
              inputLabel={l10n.formatText('product.search.form.origin.input.label')}
              inputPlaceholder={l10n.formatText('product.search.typeahead.placeholder.title.package.origin')}
              resultsEmptyPlaceholder={l10n.formatText(
                'product.search.typeahead.placeholder.emptyResultPlaceholder.flight'
              )}
              destination={fromDestination}
              onDestinationClear={handleDestinationClear('from')}
              onDestinationUpdate={handleDestinationUpdate('from')}
            />
          </UitkLayoutGridItem>
        )}

        <UitkLayoutGridItem>
          <DestinationTypeahead
            inputLabel={l10n.formatText('product.search.form.destination.input.label')}
            inputPlaceholder={
              (selectedLob?.id === 'stays' && l10n.formatText('product.search.typeahead.placeholder.title.hotel')) ||
              (selectedLob?.id === 'flights' &&
                l10n.formatText('product.search.typeahead.placeholder.title.package.destination')) ||
              ''
            }
            resultsEmptyPlaceholder={
              (selectedLob?.id === 'stays' &&
                l10n.formatText('product.search.typeahead.placeholder.emptyResultPlaceholder.hotel')) ||
              (selectedLob?.id === 'flights' &&
                l10n.formatText('product.search.typeahead.placeholder.emptyResultPlaceholder.flight')) ||
              ''
            }
            destination={toDestination}
            onDestinationClear={handleDestinationClear('to')}
            onDestinationUpdate={handleDestinationUpdate('to')}
          />
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </section>
  );
}

export { Destinations };
